export default "__VITE_ASSET__DvClzllU__"